import { useTranslation } from 'react-i18next';
import { MinusIcon, PlusIcon } from './icons';

/**
 * − [n] + control. The number is a real input (type="number") so it can be
 * typed and is announced; the buttons are labelled. Clamped to min..max.
 */
export default function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 20,
  label,
  size = 'md',
  id,
  className = '',
}) {
  const { t } = useTranslation();
  const clamp = (n) => Math.max(min, Math.min(max, n));
  const h = size === 'sm' ? 'h-10' : 'h-12';
  const btn = `flex ${h} w-10 shrink-0 items-center justify-center text-ink transition-colors hover:bg-ink/5 disabled:cursor-not-allowed disabled:opacity-35`;
  return (
    <div
      className={`inline-flex items-center rounded-btn border border-border bg-surface ${className}`}
      role="group"
      aria-label={label || t('cart.quantity')}
    >
      <button
        type="button"
        className={`${btn} rounded-l-btn`}
        onClick={() => onChange(clamp(value - 1))}
        disabled={value <= min}
        aria-label={t('cart.decrease')}
      >
        <MinusIcon className="h-4 w-4" />
      </button>
      <input
        id={id}
        type="number"
        inputMode="numeric"
        min={min}
        max={max}
        value={value}
        onChange={(e) => {
          const n = parseInt(e.target.value, 10);
          if (Number.isFinite(n)) onChange(clamp(n));
        }}
        aria-label={t('cart.quantity')}
        className={`${h} w-10 appearance-none border-0 bg-transparent p-0 text-center text-[15px] font-semibold tabular-nums text-ink focus:outline-none focus:ring-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none`}
        style={{ MozAppearance: 'textfield' }}
      />
      <button
        type="button"
        className={`${btn} rounded-r-btn`}
        onClick={() => onChange(clamp(value + 1))}
        disabled={value >= max}
        aria-label={t('cart.increase')}
      >
        <PlusIcon className="h-4 w-4" />
      </button>
    </div>
  );
}
